import { render, staticRenderFns } from "./Flashcard.vue?vue&type=template&id=e9999a94&scoped=true&"
import script from "./Flashcard.vue?vue&type=script&lang=js&"
export * from "./Flashcard.vue?vue&type=script&lang=js&"
import style0 from "./Flashcard.vue?vue&type=style&index=0&id=e9999a94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9999a94",
  null
  
)

export default component.exports